var React = require('react');

function GoogleAds (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M43.864 64.253l17.997.003-.018-.041L37.266-9.537v70.98c1.671 1.724 4 2.81 6.598 2.81","fill":"#13A564","key":0}),React.createElement("path",{"d":"M24.903 27.307l10.271 30.826c.003.006.003.012.006.023.448 1.251 1.172 2.355 2.077 3.29V-9.532l-.026-.07-12.328 36.909z","fill":"#097243","key":1}),React.createElement("path",{"d":"M12.581-9.604l-.006.026-.009-.026-24.604 73.822-.018.038H5.941a9.126 9.126 0 0 0 6.601-2.818 9.19 9.19 0 0 0 2.074-3.287c.003-.012.003-.018.006-.018L37.236-9.613H12.575v.009h.006z","fill":"#4D7BBE","key":2})]));
}

GoogleAds.defaultProps = {"width":"75","height":"75","viewBox":"-13 -10 75 75"};

module.exports = GoogleAds;

GoogleAds.default = GoogleAds;
